import {
    IUnorderedVerticalListItem,
    UnorderedVerticalList,
    createUnorderedVerticalList,
} from '@vfde-brix/ws10/unordered-vertical-list';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';
import { getBenefitListCMSConfig } from '../util/cms';
import { BenefitListCmsConfig } from '../interface';
import { decodeHtml } from '@vfde-sails/utils';

/**
 * Create Brix Unordered Vertical List component.
 * @param {HtmlId} id - Wrapper ID of the element.
 * @returns {UnorderedVerticalList|null} Unordered Vertical List component
 * or null if element with given id is not found.
 */
export const mountUnorderedVerticalList = (id: HtmlId): UnorderedVerticalList | null =>
    createComponentById(createUnorderedVerticalList, id, NO_PATTERN_BUSINESS_LOGIC);

/**
 * Get list items for UnorderedVerticalList component.
 * @param {BenefitListCmsConfig} cmsData - CMS config data for the list items.
 * @param {number} index - Number of the item.
 * @returns {IUnorderedVerticalListItem} IUnorderedVerticalListItem
 */
const getListItem = (cmsData: BenefitListCmsConfig, index: number): IUnorderedVerticalListItem => ({
    business: NO_PATTERN_BUSINESS_LOGIC,
    stdHeadline: decodeHtml(cmsData.headline),
    txtText: cmsData.subline,
    stdIcon: cmsData.iconUrl || '',
    optSize: 'small',
    containerTooltip: cmsData.tooltip ? {
        stdTooltipId: `benefit-list-${index}-tooltip`,
        txtContent: cmsData.tooltip.text,
        stdHeadline: cmsData.tooltip.headline,
        business: NO_PATTERN_BUSINESS_LOGIC,
    } : undefined,
});

/**
 * Update Unordered Vertical List component.
 * @param {UnorderedVerticalList|null} vList - Component to update.
 * @param {string=} selectedId - Selected product metacode.
 */
export const updateBenefitsList = (vList: UnorderedVerticalList | null, selectedId: string) => {
    const cmsBenefits = getBenefitListCMSConfig(selectedId);
    // TODO: check availability in API
    // TODO: hide if error case, should we even hide it? not in the briefing

    vList?.update({ listUnorderedVerticalListItems: cmsBenefits.map(getListItem) });
};
